import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { SharedService } from '@services/shared.service';

import { ApiTransactionService } from '@services/api-transaction.service';
import { TransactionModel, TransactionNotesModel, TransactionTransferModel } from '@models/TransactionModel';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { FormBase } from '@shared/form-base.component';
import { ApiAccountService } from '@services/api-account.service';
import { CustomerModel, CustomerPhoneFindModel } from '@shared/models/CustomerModel';
import { SweetAlertResult } from 'sweetalert2';
import { AssignedType, Country, RedeemedType } from '@shared/models/Enums';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-send-givi-sms',
    templateUrl: './send-givi-sms.component.html',
    styleUrls: ['./send-givi-sms.component.scss']
})
export class SendGiviSmsComponent extends FormBase<TransactionModel> implements OnInit {

    @Input() sale: TransactionModel;
    @ViewChild('showConfirmationSendGivi', { static: true }) modal: any;

    @Output() sendLink: EventEmitter<void> = new EventEmitter<void>();

    // Note
    giviNote: TransactionNotesModel;
    transactionId: number;
    customerOwnerId: number;
    formGroup: UntypedFormGroup;
    customerReceiving: CustomerModel = new CustomerModel();
    validCustomerReceiving: boolean;

    showBtn = 1; // 1-Buscar, 2-Enviar, 3-Link

    constructor(public location: Location,
        public router: Router,
        public sharedService: SharedService,
        public apiTransactionService: ApiTransactionService,
        public apiAccountService: ApiAccountService,
        private formBuilder: UntypedFormBuilder,
        private modalService: NgbModal) {
        super();
    }

    ngOnInit(): void {
        this._formInit();
    }

    onSendLink() {

        this.sendLink.next();
    }

    onSubmit(): void {

        setTimeout(() => {

            // if is invalid, show the form errors
            if (this.formGroup.invalid || !this.validCustomerReceiving || this.customerReceiving == null) {

                this.touched = false;
                return;
            }

            if (this.sale.customerOwnerId != this.customerReceiving.id) {

                this.openModal();
            }
            else {
                this.sharedService.showErrorAlert(null, 'No puedes enviar un Givi a tu misma cuenta');
            }
        }, 500);
    }

    // Form
    get phone() { return this._formGet(this.formGroup, 'phone'); }
    get invalidPhone(): boolean {
        if (this._isInvalid(this.formGroup, 'phone', this.touched)) {
            return true;
        }
        return false;
    }

    private _formInit(): void {

        // Reset for hide form errors
        this.touched = true;

        let phoneCountry = '+506';
        let countryCode = 'CR';
        if (this.sale?.country == Country.PA) {
            phoneCountry = '+507';
            countryCode = 'PA';
        }

        this.formGroup = this.formBuilder.group(
            {
                phoneCountry: new UntypedFormControl(
                    phoneCountry,
                    [Validators.required]
                ),
                phone: [
                    { number: '', countryCode: countryCode, dialCode: phoneCountry },
                    [Validators.required]
                ]
            }
        );
    }

    // End Form

    onSearchPhone(opc) { 

        //opc 1 called from the change and opc 2 called from the search buttom

        this.validCustomerReceiving = false; 

        if(opc == 1){

            this.showBtn =1;
            
        }else{
            
            //just make the call to the api when the buttom is clicked

            let customer = new CustomerPhoneFindModel();
            customer.phoneCountry = this.phone.value?.dialCode;
            customer.phone = this.phone.value?.number?.replace(/ /g, '').replace(/-/g, '').trim();

            this._getAccountWithPhone(customer);
        } 
    }

    openModal() {

        this.modalService.open(this.modal, {
            backdrop: 'static', keyboard: false,
            size: 'lg', centered: true, windowClass: 'modal-full'
        });
    }

    closeModal() {

        this.modalService.dismissAll();
    }

    updateTransaction() {

        // Set Info
        const transactionTransferModel = new TransactionTransferModel();
        transactionTransferModel.id = this.sale.id;
        transactionTransferModel.type = this.sale.type;
        transactionTransferModel.customerEmail = this.customerReceiving.email;
        transactionTransferModel.customerId = this.customerReceiving.id;
        transactionTransferModel.redeemedType = RedeemedType.GiviApp;
        transactionTransferModel.assignedType = AssignedType.Sms; // Default SMS in this component

        // Open modal
        this._transferGivi(transactionTransferModel);
    }

    private _getAccountWithPhone(customer: CustomerPhoneFindModel): void {

        this.sharedService.setLoading(true);

        this.apiAccountService.getAccountWithPhone(customer).then(
            (customer: CustomerPhoneFindModel) => {

                this.customerReceiving = customer;
                this.validCustomerReceiving = this.customerReceiving == null ? false : true;

                if(this.validCustomerReceiving == false) this.showBtn = 3;
                else this.showBtn = 2;

                this.sharedService.setLoading(false);
            }
        ).catch(
            () => {

                this.customerReceiving = null;
                this.validCustomerReceiving = this.customerReceiving == null ? false : true;
                
                if(this.validCustomerReceiving == false) this.showBtn = 3;
                else this.showBtn = 2;

                this.sharedService.setLoading(false);
            }
        );
    }

    private _transferGivi(givi: TransactionTransferModel): void {

        this.sharedService.setLoading(true);

        this.apiTransactionService.transferGivi(givi, this.sale?.country).then(
            (transaction) => {

                let couponPoints = false;

                if(this.router.url.split('/')[1] == 'accumulateCupon'){
                    couponPoints = true;
                }

                this.sharedService.setLoading(false);

                this.sharedService.showOpenGiviWithHtmlBtn(
                    `¡Boom! Givi Enviado`,
                    `Ahora el Givi le pertenece a ${this.customerReceiving.name}`,
                    `${couponPoints ? 'Balance' : 'Mis Givis'}`
                ).then(
                    (result: SweetAlertResult) => {

                        this.closeModal();
                        
                        if(couponPoints) this.router.navigate([`/balance`]);
                        else {

                            let url = this.router.url;
        
                            this.router.navigateByUrl('/market', { skipLocationChange: true }).then(() => {
                                this.router.navigateByUrl(url);
                            });
                        }
                        
                    }
                );
            }
        ).catch(err => {

            this.sharedService.showErrorAlert(null, err?.error?.Message);
            this.sharedService.setLoading(false);
        });
    }
}
